// Source/Article-Overview/mod.ts
var Selector_Headings = `.article-template__content h2`;
var Selector_Anchors = `.Article-Legend-Tags`;
var headings = document.querySelectorAll(Selector_Headings);
var anchors = document.querySelectorAll(Selector_Anchors);
var tags = Array.from(headings).map((heading) => heading.innerText).map((text) => text.trim());
var info = tags.join(" | ");
anchors.forEach((anchor) => anchor.innerText = info);
